import { isMobile } from "./Config";

export class ChangePOIControl {
    hbdmap;
    _map;
    _container;
    _popup;

    constructor(hbdmap) {
        this.hbdmap = hbdmap;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className =
            "mapboxgl-ctrl mapboxgl-ctrl-group toGroup d-block";
        this._container.appendChild(this.createPopup());
        this._container.appendChild(this.createButton());
        if (!isMobile.matches) {
            this._container.addEventListener("mouseenter", (e) => {
                e.target.parentNode
                    .querySelector("#poiList")
                    .classList.toggle("hidden");
            });
            this._container.addEventListener("mouseleave", (e) => {
                e.target.parentNode
                    .querySelector("#poiList")
                    .classList.toggle("hidden");
            });
        }
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }

    hideMe() {
        this._popup.classList.add("hidden");
    }

    createPopup() {
        this._popup = document.createElement("div");
        this._popup.setAttribute("id", "poiList");
        this._popup.className = "mapControlPopup hidden";

        let $inner = document.createElement("ul");
        $inner.className = "row inner";

        this.hbdmap.poiconfig.forEach((item) => {
            if (!item.hidden) {
                let $item = document.createElement("li");
                $item.className =
                    "col-24" + (item.defaultsel ? " selected" : "");
                $item.setAttribute("data-value", item.id);

                let $text = document.createElement("span");
                $text.innerHTML = item.label;

                $item.appendChild($text);
                $inner.appendChild($item);

                $item.addEventListener("click", (e) => {
                    let theTarget;
                    if (e.target.tagName.toUpperCase() == "LI") {
                        theTarget = e.target;
                    } else {
                        theTarget = e.target.parentNode;
                    }

                    let $theIcon = $(theTarget).find("i");

                    if (theTarget.classList.contains("selected")) {
                        $theIcon.removeClass("icon-check");
                        $theIcon.addClass("icon-check-empty");
                    } else {
                        $theIcon.removeClass("icon-check-empty");
                        $theIcon.addClass("icon-check");
                    }
                    $(theTarget).toggleClass("selected");

                    this.hbdmap.poiconfig.forEach((el) => {
                        if (el.id == theTarget.dataset.value) {
                            el.defaultsel =
                                theTarget.classList.contains("selected");
                        }
                    });

                    this.hbdmap.getPOIs("route");
                });
            }
        });

        this._popup.appendChild($inner);

        return this._popup;
    }
    createButton() {
        let $button = document.createElement("button");
        $button.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-poiView";
        $button.setAttribute("type", "button");
        $button.setAttribute("title", "Anzeige der POI ändern");
        $button.setAttribute("aria-label", "Anzeige der POI ändern");
        if (isMobile.matches) {
            $button.addEventListener("touchend", (e) => {
                e.target.parentNode
                    .querySelector("#poiList")
                    .classList.toggle("hidden");
                e.target.parentNode
                    .querySelector("#styleList")
                    .classList.add("hidden");
            });
        }
        return $button;
    }
}